import { ChangeEvent, useRef } from "react";
import { useDispatch } from "react-redux";
import { unwrapResult } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

import { errorNormalizer } from "../../../shared/Helpers/functions";
import { CustomButton } from "../../../shared/uiComponents";

import { DispatchProperties, useSelector } from "../../../redux/store";
import { uploadAssessmentReport } from "../../../redux/State/clientSlice/programTargetSlice";

const UploadAssessmentReport = () => {
  const dispatch = useDispatch<DispatchProperties>();
  const inputRef = useRef<HTMLInputElement | null>(null);

  const loading = useSelector((state) => state.programTarget.loading);
  const clientId = useSelector((state) => state.billing.billingFilters.clientId);

  const uploadXLSXFile = ({ target }: ChangeEvent<HTMLInputElement>) => {
    if (!target) return;
    const { files } = target;
    if (!files) return;
    const file = files[0];
    if (!file || !clientId) return;

    dispatch(uploadAssessmentReport({ file, clientId }))
      .then(unwrapResult)
      .then(() => {
        toast.success("Assessment report uploaded successfully.");
      })
      .catch(errorNormalizer)
      .finally(() => {
        target.value = ""; //enable reupload same file
      });
  };

  const onUploadClick = () => {
    if (!inputRef || !inputRef.current) return;
    inputRef.current.click();
  };

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        id="upload-excel-file"
        onChange={uploadXLSXFile}
        formEncType="multipart/form-data"
      />
      <CustomButton title="Upload" onClick={onUploadClick} loading={loading} disabled={!clientId} />
    </>
  );
};

export default UploadAssessmentReport;
